export default __webpack_public_path__ + "static/media/check.649a5dd2.svg";